import React, { Fragment, useState, useEffect, useRef } from 'react'
import * as R from 'ramda'
import tremApi from '../../../../../../util/tremApi'
import { getAmountKo } from '../../../../../../util/collabi'
import { serverUrl, serverPrefixUrl } from '../../../../../../config'
import G from '../../../../../../util/globalFunction'

import ReactToPrint from 'react-to-print' 

export default props => {
    const {clickRef, param, click, getPopupValFn} = props
    let {pdfRef} = props
    const ESTIMATE_SKEY = param?.ESTIMATE_SKEY
    
    useEffect(() => {
        tremApi("/r/hm/equipEstimate/estimate/print/pop", {ESTIMATE_SKEY: ESTIMATE_SKEY}).then(data => {
            setEstimateData(data)
        })
    }, [])

    useEffect(() => {
        click ===true&&getPopupValFn(estimateData?.estimate)
    }, [click])

    const [estimateData, setEstimateData] = useState({
        estimate: {},
        estimateChargeList: [],
        invoiceSetInfo: {},
        defaultInfo: {}
    })

    const inputRefdiv = useRef([]);

    useEffect(() => {
        inputRefdiv.current[0].focus();
    }, [])

    const {estimate, estimateChargeList, invoiceSetInfo, defaultInfo} = estimateData

    const handleImgError = (e) =>{
        e.target.style.display = "none";
    }

    let printRef = useRef(null)
    return <Fragment>
        <ReactToPrint ref={clickRef}
            pageStyle={`@page { size: auto;  margin: 6mm; } @media print { body { -webkit-print-color-adjust: exact; } }`}
            content={() => printRef}
        />
        
        <div tabIndex={0} ref={(val) => (inputRefdiv.current[0] = val)} id="estimateFormCanvas" className="estimate_document_wrap">
        <div ref={pdfRef}>
            <h2>{estimate.ESTIMATE_TYPE === 'FE' ? G.t('trem.lang.home.1180' /*가견적서*/) : G.t('trem.lang.home.0021')}</h2>{/* <h2>{estimate.ESTIMATE_TYPE === 'FE' ? '가견적서' : '견적서'}</h2> */}

            {estimate.ESTIMATE_TYPE === 'FE'
            ? <Fragment>
                <p>{estimate.COMP_DT_KO}</p>
                <br/>
                {estimate.CDTYPE_NAME && <p>{estimate.CDTYPE_NAME}</p>}
                <p>{estimate.REQUESTER_NAME} 귀하</p>
            </Fragment>
            : <div className="oe_info">
                <table className="em_table oe_info_right" style={{border: '2px solid black'}}>
                    <caption> 견적서 표 - 공급자, 사업자등록번호, 상호(법인명), 성명, 사업장 주소, 업태, 종목으로 구성</caption>
                    <tbody>
                        <tr>
                            <td rowSpan="4">
                                <span className="infoSpan">{estimate.COMP_DT_KO}</span>
                                {estimate.CDTYPE_NAME
                                && <p className="infoP">{estimate.CDTYPE_NAME}</p>}
                                <p className="infoP">{estimate.REQUESTER_NAME} 귀하</p>
                            </td>
                            <th scope='col' rowSpan="4" style={{fontSize: '16px'}}>공<br/><br/>급<br/><br/>자</th>
                            <th scope='col' style={{padding: '3px 3px', fontSize: '13px'}}>사업자<br/>등록번호</th>
                            <td colSpan="3">{defaultInfo.BIZ_NO}</td>
                        </tr>
                        <tr>
                            <th scope='col'>상호(법인명)</th>
                            <td>{defaultInfo.COMPANY_NAME}</td>
                            <th scope='col'>성명</th>
                            <td>{defaultInfo.CEO}</td>
                        </tr>
                        <tr>
                            <th scope='col'>사업장 주소</th>
                            <td colSpan="3">{defaultInfo.ADDRESS}</td>
                        </tr>
                        <tr>
                            <th scope='col'>업태</th>
                            <td>{defaultInfo.WKTP}</td>
                            <th scope='col'>종목</th>
                            <td>{defaultInfo.BIZTP}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            }

            <div className="em_amount" style={{border: '2px solid black'}}>
                <span>
                    견적금액 
                    {estimate.COMPANY_TYPE != 'I' 
                    && ` (${G.t('trem.lang.home.0122')}) `/* (VAT 포함) */
                    }
                </span>
                <span className="em_amount_ko">
                    {estimate.RESULT_AMOUNT
                    && '일금'+ getAmountKo(estimate.RESULT_AMOUNT)}
                </span>
                <span> (\ {(estimate.RESULT_AMOUNT || '').toLocaleString()})</span>
            </div>

            <table className="em_table" style={{border: '2px solid black'}}>
                <caption> {estimate.ESTIMATE_TYPE === 'FE' ? '가견적서' : G.t('trem.lang.home.0021')} 표 - 
                    No, 장비/ 재료명, 수량, 청구단위, 단가, 할인율, 금액, 세액, 비고로 구성
                </caption>
                <tr>
                    <th scope="col">No.</th>
                    <th scope="col">장비/재료명</th>
                    <th scope="col">{G.t('trem.lang.home.0111')}</th>{/* 수량 */}
                    <th scope="col">{G.t('trem.lang.home.0914')}<br/>{G.t('trem.lang.home.0114')}</th>{/* 청구 청구단위 */}
                    <th scope="col">{G.t('trem.lang.home.0100')}<br/>({G.t('trem.lang.home.0781')})</th>{/* 단가(원) */}
                    <th scope="col">{G.t('trem.lang.home.0068')}<br/>(%)</th>{/* 할인율(%) */}
                    <th scope="col">{G.t('trem.lang.home.0102')}<br/>({G.t('trem.lang.home.0782')})</th>{/* 금액(VAT별도) */}
                    <th scope="col">세액</th>
                    <th scope="col">{G.t('trem.lang.home.0074')}</th>{/* 비고 */}
                </tr>
                {
                    estimateChargeList.map((obj, index) => {
                        const repeatAreaCount =  estimateChargeList[0].REPEAT_AREA_COUNT || 0
                        const rendering = () => {
                            let result = []
                            for( let i=0; i<repeatAreaCount; i++ ) {
                                result.push(
                                    <tr key={i}>
                                        <td>{repeatAreaCount*index+i+1}</td>
                                        <td>{obj.TITLE}</td>
                                        <td>{obj.FINAL_UOM==="시간" ? obj.USE_TIME : obj.TOTAL_QUANTITY}</td>{/*obj.TOTAL_QUANTITY*/}
                                        <td>{obj.FINAL_UOM}</td>
                                        <td className="r">\  
                                            {
                                            obj.NOTE ==="equip" &&
                                            estimate?.CHARGE_TYPE === '01' && 
                                            obj?.TIME_UNIT != '1' &&
                                            obj?.TIME_UNIT != '60'
                                            ? (obj?.COST *(60 / obj?.TIME_UNIT) || 0).toLocaleString()
                                            : (obj?.COST).toLocaleString()

                                            }
                                        </td>{/*(obj.COST || '').toLocaleString()*/}
                                        
                                        <td>{obj.DISCOUNT_RATE}</td>
                                        <td className="r">\ {(obj.EXCEPT_TAX_AMOUNT || '').toLocaleString()}</td>
                                        <td className="r">\ {(obj.TAX_AMOUNT || '').toLocaleString()}</td>
                                        <td>{obj.DESCRIPTION}</td>
                                    </tr>
                                )
                            } 
                            return result
                        }
                        return ( 
                            <Fragment>
                                {repeatAreaCount > 0
                                ? <Fragment>{rendering()}</Fragment>
                                : <tr key={index}>
                                        <td>{index+1}</td>
                                        <td>{obj.TITLE}</td>
                                        <td>{obj.FINAL_UOM==="시간" ? obj.USE_TIME : obj.TOTAL_QUANTITY}</td>{/*obj.TOTAL_QUANTITY*/}
                                        <td>{obj.FINAL_UOM}</td>
                                        <td className="r">\  
                                            {
                                            obj.NOTE ==="equip" &&
                                            estimate?.CHARGE_TYPE === '01' && 
                                            obj?.TIME_UNIT != '1' &&
                                            obj?.TIME_UNIT != '60'
                                            ? (obj?.COST *(60 / obj?.TIME_UNIT) || 0).toLocaleString()
                                            : (obj?.COST).toLocaleString()
                                            }
                                        </td>{/*(obj.COST || '').toLocaleString()*/}
                                        <td>{obj.DISCOUNT_RATE}</td>
                                        <td className="r">\ {(obj.EXCEPT_TAX_AMOUNT || '').toLocaleString()}</td>
                                        <td className="r">\ {(obj.TAX_AMOUNT || '').toLocaleString()}</td>
                                        <td>{obj.DESCRIPTION}</td>
                                </tr>
                                }
                                {estimateChargeList.length-1 === index
                                ? <tr>
                                    <th colSpan="6">합&emsp;계</th>
                                    <td className="r">\ {obj.TOTAL_EXCEPT_TAX_AMOUNT}</td>
                                    <td className="r">\ {obj.TOTAL_TAX_AMOUNT}</td>
                                    <td>{estimate.NOTE}</td>
                                </tr>
                                :''
                                }
                            </Fragment>
                        )
                    })
                }
            </table>

            <br/>
		    <h4 style={{fontSize: '13px'}}>※ 상기 견적은 의뢰인이 입력한 조건과 기준을 토대로 작성된 견적이며, 실제 장비 이용시 의뢰자의 장비 세부사항 또는 시료 준비 상태 등의 요인에 의해 변경될 수 있으므로 단순참고용 자료로만 활용 가능합니다.</h4>

            {estimate.ESTIMATE_TYPE === 'OE'
            && <div className="oe_seal" >
                <p className="oe_date">{estimate.COMP_DT_KO}</p>
                <p className="oe_title">{defaultInfo.TYPE === 'KIST' ? invoiceSetInfo.SEAL_NAME : defaultInfo.COMPANY_NAME}</p>

                {estimate.STATUS === 'CP' && defaultInfo.TYPE === 'KIST'
                ? <img className="oe_stamp" src={serverUrl + serverPrefixUrl + "/attach/download?FILE_SKEY=" + invoiceSetInfo.FILE_SKEY} onError={handleImgError}/>
                 : <img className="oe_stamp" src={serverUrl + serverPrefixUrl + defaultInfo.JICKIN}/> 
                }
            </div>}

            <br/>
            <br/>
        </div>
        </div>
    </Fragment>
}